module.exports = __webpack_public_path__ + "img/201128-2.c5c4cf4c.jpeg";